<!-- OpenID 導流頁面 /not_found -->
<template>
  <div class="not_found_wrapper">
    <div class="nav">
      <picture>
        <source
          media="(min-width: 768px)"
          :srcset="require('@/assets/imgs/redirect/navbar_logo@3x.png')"
        >
        <source
          media="(max-width: 320px)"
          :srcset="require('@/assets/imgs/redirect/navbar_logo.png')"
        >
        <img
          class="pxplus_logo"
          :src="require('@/assets/imgs/redirect/navbar_logo@2x.png')"
          alt="logo"
        >
      </picture>
    </div>

    <div class="container">
      <div class="qrcode_error">
        <picture>
          <source
            media="(min-width: 768px)"
            :srcset="require('@/assets/imgs/redirect/qrcode_error@3x.png')"
          >
          <source
            media="(max-width: 320px)"
            :srcset="require('@/assets/imgs/redirect/qrcode_error.png')"
          >
          <img
            class="qrcode_error_img"
            :src="require('@/assets/imgs/redirect/qrcode_error@2x.png')"
            alt="redirect"
          >
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style>
#app > .container {
  margin-top: 0px;
  min-height: auto;
}
</style>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

.not_found_wrapper {
  background: $mono_10;
  height: 100vh;
  text-align: center;

  .nav {
    background: $white;
    padding: 25px 0px 25px 50px;
    text-align: left;

    .pxplus_logo {
      width: 155px;
      height: 31px;
    }
  }

  .container {
    .qrcode_error {
      margin-top: 100px;
      text-align: center;

      img {
        width: 250px;
      }
    }
  }
}

@media screen and (max-width: 1024px) and (min-width: 768px) {
  .not_found_wrapper {
    .container {
      .qrcode_error {
        margin-top: 182px;
      }
    }
  }
}

@media screen and (max-width: 1023px) and (min-width: 414px) {
  .not_found_wrapper {
    .nav {
      padding: 25px 0px 25px 30px;
    }
  }
}
</style>
